module.exports = __webpack_public_path__ + "assets/img/dislike.2e119571.svg";